import * as React from "react";
// UI Frameworks
import { Form, Button as AntButton } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Input from "components/Input";
import Button from "components/Button";
// Hooks
import { normalizeNumbers } from "helpers/persian";
// Styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	onSubmit: (data: any) => void;
	onChangeUsername: () => void;
	loading: boolean;
	inputValue: string;
}

const GetCode: React.FC<IProps> = props => {
	const { getFieldDecorator } = props.form;
	// const isMobile = window.location.host === process.env.REACT_APP_INTL_DOMAIN;
	const isMobile = !props.inputValue.includes("@");
	

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields((err, values) => {
			if (!err) {
				props.onSubmit({ code: values.code });
			}
		});
	}

	return (
		<Form onSubmit={handleSubmit} className={styles["password-reset-form"]}>
			<div className={styles["password-reset-form__code-section"]}>
				<Form.Item label="کد تایید">
					{getFieldDecorator("code", {
						normalize: normalizeNumbers,
						rules: [
							{
								required: true,
								message: !isMobile
									? "لطفا کد تایید ایمیل شده را وارد نمایید"
									: "لطفا کد تایید پیامک شده را وارد نمایید",
								transform: value => (value ? value.trim() : value),
							},
						],
					})(<Input type="tel" />)}
				</Form.Item>
			</div>
			<AntButton type="link" style={{ padding: 0 }} onClick={props.onChangeUsername}>
				{!isMobile && "تغییر ایمیل"}
				{isMobile && "تغییر شماره موبایل"}
			</AntButton>
			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={props.loading}>
					مرحله بعدی
				</Button>
			</Form.Item>
		</Form>
	);
};

export default Form.create<IProps>()(React.memo(GetCode));
